import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { coursesAPI } from "api/Interactions/CoursesAPI";

interface AddCoursePopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newCourse: any) => void;
}

const AddCoursePopup: React.FC<AddCoursePopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Course"
      createFunction={coursesAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description", required: true },
        { name: "linked_campaign", label: "Campaign" },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddCoursePopup;
